import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";
import { currentlyConfiguring724 } from "nexia_mobile/api/xr724";
import { currentlyConfiguringDragonfly } from "nexia_mobile/api/dragonfly";
import LocalSettings from "nexia_mobile/models/local_settings";
import EventStream from "nexia_mobile/event_stream";
import { getLanguageSet } from "nx-components/Locales";

Dispatch.on("NETWORK_CONNECTION_DOWN", () => {
  setValueAtPath("isNetworkConnected", false);
});

Dispatch.on("NETWORK_CONNECTION_UP", () => {
  setValueAtPath("isNetworkConnected", true);
  EventStream.checkForReconnect();
});

Dispatch.on("NETWORK_REQUEST_TIMEOUT", () => {
  const localeSet = getLanguageSet();
  const language = localeSet.nexia_mobile.utils.flux_like.network;
  if (currentlyConfiguring724() || currentlyConfiguringDragonfly()) {
    // Don't show toasts for request timeouts during 724 enrollment,
    // because we disconnect from the WiFi network while polling a Backstage Url
    // during part of the enrollment process.
    return;
  }
  Dispatch("SHOW_TOAST", language.requestTimedOut);
});

Dispatch.on("PUBLISH_SETTINGS_TO_SERVER", () => LocalSettings.publish());

Dispatch.on("SERVERSIDE_ERROR_OCCURRED", (errors) => {
  if (!_.isArray(errors)) {
    return;
  }

  if (Store.isNetworkConnected === false) {
    return;
  }

  errors.forEach((error) => {
    Dispatch("SHOW_TOAST", error.errorMessage);
  });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/network.js